import { getUniversalCookies } from '../util/CookiesUtils';
import Api from './Api';

class LoginApi extends Api {
  async realizarLogin (codUsuario, senha) {
    let headers = {
      'authorization': 'Basic ' + btoa(codUsuario + ':' + senha),
      'Content-Type': 'application/vnd.tst.token+json; versao=1;charset=UTF-8'
    };

    let ssoRequest = await this.getUrl(this.configuracao.urlLogin, headers);
    let tokenSSO = ssoRequest.data;
    if (tokenSSO.token === undefined) {
      throw new Error(tokenSSO.mensagem);
    }

    let usuarioSso = this.converterToken(tokenSSO.token);
    usuarioSso.ssoToken = tokenSSO.token;
    usuarioSso.ssoTokenValidade = tokenSSO.validade;
    getUniversalCookies().set('ssoToken', usuarioSso.ssoToken, { path: '/', domain: this.resolveDomain() });
    return usuarioSso;
  }

  resolveDomain () {
    let hostname = window.location.hostname;
    const interno = '.rede.tst';
    const externo = '.tst.jus.br';
    if (hostname.search(interno) > 0) return interno;
    if (hostname.search(externo) > 0) return externo;
  }

  converterToken (tokenBase64) {
    if (tokenBase64) {
      let tokenArray = tokenBase64.split('.');
      if (tokenArray.length === 3) {
        return JSON.parse(atob(tokenArray[1]));
      }
    }
    throw new Error('Não foi possível converter o token de autenticação.');
  }
}

export default LoginApi;
